/*
 * @Author: xianghongai@gmail.com
 * @Date: 2017-11-27 16:59:29
 * @Last Modified by: Nicholas Hsiang
 * @Last Modified time: 2017-11-27 17:55:17
 *
 * [依赖underscore](https://cdn.bootcss.com/underscore.js/1.8.3/underscore-min.js)
 * [依赖gb2260](https://github.com/cn/GB2260.js/blob/develop/dist/gb2260.js)
 * [街道数据](https://github.com/mumuy/data_location)
 * [省市县级数据](https://github.com/cn/GB2260.js)
 * TODO: 街道数据、数据本地持久存储
 */


var hs = hs || {};


hs.area = function(param) {
    param = param || {};
    // 入口
    this.container = param.container || '[data-area="container"]';

    // 显示结果
    this.result = param.result || '[data-area="result"]';

    // 触发标签
    this.triggerClass = param.triggerClass || ".select-area-item";
    this.triggerActiveClass = param.triggerActiveClass || "select-area-item-active";
    this.triggerEnableClass = param.triggerEnableClass || "select-area-item-enable";
    this.triggerDisableClass = param.triggerDisableClass || "select-area-item-disable";

    this.provinceTrigger = param.provinceTrigger || '[data-area-item="provinces"]';
    this.prefectureTrigger = param.prefectureTrigger || '[data-area-item="prefectures"]';
    this.countyTrigger = param.countyTrigger || '[data-area-item="counties"]';

    // 触发标签获取相应名
    this.name = param.name || '[data-area="name"]';

    // 相关数据面板
    this.panelClass = param.panelClass || '.select-area-panel';
    this.panelActiveClass = param.panelActiveClass || 'select-area-panel-active';
    this.provincePanel = param.provincePanel || '[data-area-panel="provinces"]';
    this.prefecturePanel = param.prefecturePanel || '[data-area-panel="prefectures"]';
    this.countyPanel = param.countyPanel || '[data-area-panel="counties"]';

    // 默认激活，返回值
    this.activeProvince = "";
    this.activePrefecture = "";
    this.activeCounty = "";
    this.activeProvinceCode = param.activeProvinceCode || "";
    this.activePrefectureCode = param.activePrefectureCode || "";
    this.activeCountyCode = param.activeCountyCode || "";

    // 数据项标签类型
    this.optionType = param.optionType || 'li';
    this.optionClass = param.optionClass || 'area-item';

    this._result = "";
    this.required = param.required || true; // 是否必须选一个
};

hs.area.prototype.init = function() {

    var _this = this;

    var $container = $(_this.container);
    var $result = $container.find(_this.result);

    var $trigger = $container.find(_this.triggerClass);
    var $provinceTrigger = $container.find(_this.provinceTrigger);
    var provinceTriggerLength = $provinceTrigger.length;
    var $prefectureTrigger = $container.find(_this.prefectureTrigger);
    var prefectureTriggerLength = $prefectureTrigger.length;
    var $countyTrigger = $container.find(_this.countyTrigger);
    var countyTriggerLength = $countyTrigger.length;

    var $provinceTriggerName = $provinceTrigger.find(_this.name);
    var $prefectureTriggerName = $prefectureTrigger.find(_this.name);
    var $countyTriggerName = $countyTrigger.find(_this.name);

    var $panel = $container.find(_this.panelClass);
    var $provincePanel = $container.find(_this.provincePanel);
    var provincePanelLength = $provincePanel.length;
    var $prefecturePanel = $container.find(_this.prefecturePanel);
    var prefecturePanelLength = $prefecturePanel.length;
    var $countyPanel = $container.find(_this.countyPanel);
    var countyPanelLength = $countyPanel.length;

    var _optionType = _this.optionType;


    // 触发项不是必需项，面板项是必需项；
    // 面板项可以配合触发项通过样式做成类下拉选择的效果，交互效果更丰富；
    // 面板项可以独立存在，展示区域列表信息；
    $.ajax({
        type: "GET",
        // [街道数据使用：lib\gb2260\town\*.json](https://github.com/mumuy/data_location)
        // [省市县级数据使用：lib\gb2260\list.json](https://github.com/cn/GB2260.js)
        url: "http://app.culturedc.cn/lib/gb2260/list.jsonp",
        jsonpCallback: "jsonp_location",
        dataType: "jsonp",
        success: function(data) {
            // gb2260.js 使用:https://github.com/cn/GB2260.js/blob/develop/dist/gb2260.js，并将 es5 语法部分修改成了 underscore.js 的方法

            var gb = new gb2260.GB2260({
                data: data
            });


            /**
             * 获取所有省级数据
             * @returns - 省级数据数组
             */
            function getProvinces() {
                return gb.provinces();
            }

            /**
             * 根据省级获取市级
             * @param {any} code - 省级区域编码(例如:430000)
             * @returns - 市级数据数组
             */
            function getPrefectures(code) {
                return gb.prefectures(code);
            }

            /**
             * 根据市级获取县级
             * @param {string} code - 市级区域编码(例如:433100)
             * @returns - 县级数据数组
             */
            function getCounties(code) {
                return gb.counties(code);
            }

            /**
             * 根据区域编码获取相关数据
             * @param {string} code - 区域编码
             * @returns 相关数据
             */
            function get(code) {
                return gb.get(code);
            }

            // 根据数据设置并生成模板
            function setData(param) {
                var data = param.data;
                var $inner = param.$inner;
                var index = param.index || 0; // TODO: 默认显示项
                var dataLength = data.length;
                var tpl = [];
                for (var i = 0; i < dataLength; i++) {
                    tpl.push('<' + _optionType + ' class="' + _this.optionClass + '" data-val="' + data[i].code + '">' + data[i].name + '</' + _optionType + '>');
                }
                $inner.html('').append(tpl);
            }

            /**
             * 设置数据面板
             * @param {object} param - \{$panel:面板类型, data:面板数据\}
             */
            function setPanel(param) {
                if (param.$panel.length) {
                    setData({
                        data: param.data,
                        $inner: param.$panel
                    });
                }
            }

            /** 设置省级数据面板 */
            function setProvincePanel() {
                setPanel({
                    $panel: $provincePanel,
                    data: getProvinces()
                });
            }

            /** 设置市级数据面板 */
            function setPrefecturePanel() {
                setPanel({
                    $panel: $prefecturePanel,
                    data: getPrefectures(_this.activeProvinceCode)
                });
            }

            /** 设置县级数据面板 */
            function setCountyPanel() {
                setPanel({
                    $panel: $countyPanel,
                    data: getCounties(_this.activePrefectureCode)
                });
            }

            /** 设置触发项 */
            function setTrigger(param) {
                if (param.$trigger.length) {
                    param.$trigger.attr(param.attrKey, param.attrValue);
                    param.$triggerName.text(param.Info);
                }
            }

            /** 设置省级触发项 */
            function setProvinceTrigger() {
                setTrigger({
                    $trigger: $provinceTrigger,
                    attrKey: "area-province-code",
                    attrValue: _this.activeProvinceCode,
                    $triggerName: $provinceTriggerName,
                    Info: _this.activeProvince
                });
            }

            /** 设置市级触发项 */
            function setPrefectureTrigger() {
                setTrigger({
                    $trigger: $prefectureTrigger,
                    attrKey: "area-prefecture-code",
                    attrValue: _this.activePrefectureCode,
                    $triggerName: $prefectureTriggerName,
                    Info: _this.activePrefecture
                });
            }

            /** 设置县级触发项 */
            function setCountyTrigger() {
                setTrigger({
                    $trigger: $countyTrigger,
                    attrKey: "area-county-code",
                    attrValue: _this.activeCountyCode,
                    $triggerName: $countyTriggerName,
                    Info: _this.activeCounty
                });
            }


            /** 根据选择实时显示结果 */
            function setResult() {
                if ($result.length) {
                    _this._result = "";
                    if (provinceTriggerLength) {
                        _this._result = _this.activeProvince + ',';
                    }
                    if (prefectureTriggerLength) {
                        _this._result += _this.activePrefecture + ',';
                    }
                    if (countyTriggerLength) {
                        _this._result += _this.activeCounty;
                    }
                    $result.text(_this._result);
                }
            }


            /**
             * 触发项开关
             * @param {object} _$item - 触发项
             * @param {object} _$panel - 触发面板
             */
            function triggerToggle(_$item, _$panel) {
                if (_$item.length && _$item.hasClass(_this.triggerActiveClass) || _$panel.length && _$panel.hasClass(_this.panelActiveClass)) {
                    _$item.removeClass(_this.triggerActiveClass);
                    _$panel.removeClass(_this.panelActiveClass);
                } else {
                    triggerActive(_$item);
                    $panel.removeClass(_this.panelActiveClass); // 所有面板移除激活
                    _$panel.addClass(_this.panelActiveClass); // 激活当前指定面板
                }
            }

            /**
             * 触发项的激活状态(active)
             * @param {object} $item - jQuery对象
             */
            function triggerActive($item) {
                if ($item.length) {
                    $item.addClass(_this.triggerActiveClass).siblings(_this.triggerClass).removeClass(_this.triggerActiveClass);
                }
            }


            /**
             * 触发项的可用状态(enable)
             * @param {object} $item
             */
            function triggerEnable($item) {
                if ($item.length) {
                    $item.addClass(_this.triggerEnableClass).removeClass(_this.triggerDisableClass);
                }
            }


            /**
             * 触发项的禁用状态(disable)
             * @param {object} $item
             */
            function triggerDisable($item) {
                if ($item.length) {
                    $item.addClass(_this.triggerDisableClass).removeClass(_this.triggerEnableClass);
                }
            }


            /**
             * 选择变化后重置关联项数据
             * @param {object} param  - \{$trigger:触发项, attrKey:触发项data属性名, attrValue:触发项data属性值, $triggerName:触发项名, Info:触发项名文本信息, $panel:面板类型\}
             */
            function reset(param) {
                if (param.$trigger.length) {
                    param.$trigger.attr(param.attrKey, param.attrValue);
                    param.$triggerName.text(param.Info);
                }
                if (param.$panel.length) {
                    param.$panel.html("");
                }
            }

            /* 相关操作 */

            // 管它的，都先禁用
            $trigger.addClass(_this.triggerDisableClass);

            // 取消激活
            $('body').on('click', function(event) {
                if (event.target.className.indexOf("select-area-item") === -1) {
                    $trigger.removeClass(_this.triggerActiveClass);
                    $panel.removeClass(_this.panelActiveClass);
                }
            });

            /* 默认初始状态: 省级数据 */
            setProvincePanel();

            /* 默认激活相关初始数据 */
            if (_this.activeProvinceCode) {
                var provinceTemp = get(_this.activeProvinceCode);
                _this.activeProvince = provinceTemp.name;
                _this.activeProvinceCode = provinceTemp.code;
                setProvinceTrigger();
                setPrefecturePanel();
            }
            if (_this.activePrefectureCode) {
                var prefectureTemp = get(_this.activePrefectureCode);
                _this.activeProvince = prefectureTemp.province.name;
                _this.activeProvinceCode = prefectureTemp.province.code;
                _this.activePrefecture = prefectureTemp.name;
                _this.activePrefectureCode = prefectureTemp.code;

                setProvinceTrigger();
                setPrefectureTrigger();
                setPrefecturePanel();
                setCountyPanel();
            }
            if (_this.activeCountyCode) {
                var countyTemp = get(_this.activeCountyCode);
                _this.activeProvince = countyTemp.province.name;
                _this.activeProvinceCode = countyTemp.province.code;
                _this.activePrefecture = countyTemp.prefecture.name;
                _this.activePrefectureCode = countyTemp.prefecture.code;
                _this.activeCounty = countyTemp.name;
                _this.activeCountyCode = countyTemp.code;

                setProvinceTrigger();
                setPrefectureTrigger();
                setCountyTrigger();
                setPrefecturePanel();
                setCountyPanel();
            }

            /* 初始显示默认结果 */
            setResult();

            /* 触发项(trigger)点击事件 */
            if (provinceTriggerLength) {
                // 反正是顶级省级数据，什么都别说，就一个字：干
                triggerEnable($provinceTrigger);
                $provinceTrigger.on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    triggerToggle($provinceTrigger, $provincePanel);
                });
            }
            if (prefectureTriggerLength) {
                // 有没有默认激活市级
                if (_this.activePrefectureCode) {
                    triggerEnable($prefectureTrigger);
                }
                $prefectureTrigger.on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    // 不能蛮干，市级数据触发前，如果有省级，则需要先选择省级
                    if (provinceTriggerLength && !_this.activeProvince || $prefectureTrigger.hasClass(_this.triggerDisableClass)) {
                        return;
                    }
                    triggerToggle($prefectureTrigger, $prefecturePanel);
                });
            }
            if (countyTriggerLength) {
                // 有没有默认激活县级
                if (_this.activeCountyCode) {
                    triggerEnable($countyTrigger);
                }
                $countyTrigger.on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    // 不能蛮干，县级数据触发前，如果有市级，则需要先选择市级
                    if (prefectureTriggerLength && !_this.activePrefecture || $countyTrigger.hasClass(_this.triggerDisableClass)) {
                        return;
                    }
                    triggerToggle($countyTrigger, $countyPanel);
                });
            }

            /* 面板(panel)选择事件 */
            if (provincePanelLength) {
                $provincePanel.on('click', '.' + _this.optionClass, function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var $this = $(this);
                    // 把选择的数据传出去
                    _this.activeProvinceCode = $this.data("val");
                    _this.activeProvince = $this.text();

                    // 设置省级视图
                    setProvinceTrigger();
                    triggerToggle($provinceTrigger, $provincePanel);

                    // 重置市级
                    _this.activePrefecture = "";
                    _this.activePrefectureCode = "";
                    reset({
                        $trigger: $prefectureTrigger,
                        attrKey: "area-prefecture-code",
                        attrValue: "",
                        $triggerName: $prefectureTriggerName,
                        Info: "市",
                        $panel: $prefecturePanel
                    });
                    setPrefecturePanel();
                    triggerEnable($prefectureTrigger);
                    triggerToggle($prefectureTrigger, $prefecturePanel);

                    // 重置县级
                    _this.activeCounty = "";
                    _this.activeCountyCode = "";
                    reset({
                        $trigger: $countyTrigger,
                        attrKey: "area-county-code",
                        attrValue: "",
                        $triggerName: $countyTriggerName,
                        Info: "县",
                        $panel: $countyPanel
                    });
                    triggerDisable($countyTrigger);

                    // 实时显示选择结果
                    setResult();
                });
            }
            if (prefecturePanelLength) {
                $prefecturePanel.on('click', '.' + _this.optionClass, function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var $this = $(this);

                    // 把选择的数据传出去
                    _this.activePrefectureCode = $this.data("val");
                    _this.activePrefecture = $this.text();

                    // 设置市级视图
                    setPrefectureTrigger();
                    triggerToggle($prefectureTrigger, $prefecturePanel);

                    // 重置县级
                    _this.activeCounty = "";
                    _this.activeCountyCode = "";
                    reset({
                        $trigger: $countyTrigger,
                        attrKey: "area-county-code",
                        attrValue: "",
                        $triggerName: $countyTriggerName,
                        Info: "县",
                        $panel: $countyPanel
                    });
                    setCountyPanel();
                    triggerEnable($countyTrigger);
                    triggerToggle($countyTrigger, $countyPanel);

                    // 实时显示选择结果
                    setResult();
                });
            }
            if (countyPanelLength) {
                $countyPanel.on('click', '.' + _this.optionClass, function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var $this = $(this);
                    // 把选择的数据传出去
                    _this.activeCountyCode = $this.data("val");
                    _this.activeCounty = $this.text();

                    // 设置县级
                    setCountyTrigger();
                    triggerToggle($countyTrigger, $countyPanel);

                    // 实时显示选择结果
                    setResult();
                });
            }

        } // success end
    });

};